import gql from 'graphql-tag';

const GIVE_FEEDBACK_MUTATION = gql`
  mutation giveFeedback(
    $templateId: ID!
    $contentId: String!
    $userId: String!
    $contentType: String!
    $contentMeta: JSONObject
    $data: JSONObject
  ) {
    giveFeedback(
      contentId: $contentId
      templateId: $templateId
      userId: $userId
      contentMeta: $contentMeta
      data: $data
      contentType: $contentType
    ) {
      code
      success
      message
    }
  }
`;

export { GIVE_FEEDBACK_MUTATION };
